import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { ExplanationGraphic } from './index';
import { AuthActionIcon, TheezyIcon } from '../icons';

const SplashPage = () => {
    const { loginWithRedirect, error } = useAuth0();

    return (
        <div className="login-layout">
            {/* ── LEFT PANEL ── */}
            <div className="login-left">
                {/* Animated background orbs */}
                <div className="orb orb-1" />
                <div className="orb orb-2" />
                <div className="orb orb-3" />

                {/* Grid overlay */}
                <div className="grid-overlay" />

                <div className="left-content">

                    {/* Logo */}
                    <div className="login-logo">
                        <TheezyIcon />
                    </div>

                    {/* Hero copy */}
                    <div className="left-hero">
                        <div className="hero-title">Your online activity.<br/><span className="hero-title-gold">Now working for you.</span></div>
                        <p className="hero-sub">
                            Turn everyday activity into real cash rewards. Easy action, easy reward.
                        </p>
                    </div>
                    <div className="explanation-wrap">
                        <ExplanationGraphic />
                    </div>
                </div>
            </div>

            {/* ── RIGHT PANEL ── */}
            <div className="login-right">
                <div className="login-card">
                    <div className="login-card-top">
                        <h2 className="card-title">Welcome back</h2>
                        <p className="card-sub">
                            Sign in to access your account and start earning rewards.
                        </p>
                    </div>
                    <div className="login-card-body">
                        {/* Auth0 login button */}
                        <button
                            type="button"
                            className="login-btn"
                            onClick={() => loginWithRedirect()}
                        >
                            <AuthActionIcon size={16} />
                            Continue with your account
                        </button>
                        {error && (
                            <div className="login-error" role="alert">
                                <span className="login-error-icon">!</span>
                                <span className="login-error-text">
                                    {error.message || 'Something went wrong signing you in'}
                                </span>
                            </div>
                        )}
                        <p className="login-hint">
                            You'll be redirected to our secure login portal.
                        </p>
                    </div>

                    <div className="login-card-footer">
                        <span>Need access?</span>
                        <Link to="/support" className="footer-link">Contact us →</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SplashPage;